import React from "react";

const OrangeDot = ({width = 32, height = 32,color = "#FF4336"}) => {
  return (
    <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_177529_8946)">
        <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#FCF5F3" />
        <g clip-path="url(#clip1_177529_8946)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 9.0625C12.1685 9.0625 9.0625 12.1685 9.0625 16C9.0625 19.8315 12.1685 22.9375 16 22.9375C19.8315 22.9375 22.9375 19.8315 22.9375 16C22.9375 12.1685 19.8315 9.0625 16 9.0625ZM7.9375 16C7.9375 11.5472 11.5472 7.9375 16 7.9375C20.4528 7.9375 24.0625 11.5472 24.0625 16C24.0625 20.4528 20.4528 24.0625 16 24.0625C11.5472 24.0625 7.9375 20.4528 7.9375 16Z" fill="#FF4336" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_177529_8946">
          <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="white" />
        </clipPath>
        <clipPath id="clip1_177529_8946">
          <rect width="18" height="18" fill="white" transform="translate(7 7)" />
        </clipPath>
      </defs>
    </svg>

  );
};

export default OrangeDot;
